import { AddressEntry } from "@app/components/AddressEntry/AddressEntry"
import { InputError } from "@app/components/core/InputError/InputError"
import { Loader } from "@app/components/core/Loader/Loader"
import Button from "@app/components/move2Library/Button/Button"
import Input from "@app/components/move2Library/Input/Input"
import { SelectBox } from "@app/components/move2Library/SelectBox/SelectBox"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import { useLogout } from "@app/store/service/authService"
import { useGetStrings } from "@app/store/service/cmsService"
import {
	useDeleteUserData,
	useGetCountries,
	useGetRelation,
	useGetRelationAddresses,
	useGetSalutations,
	useSaveUserData,
} from "@app/store/service/connectorService"
import { appStore } from "@app/store/store"
import { ADRESS_TYPES } from "@app/utils/constants"
import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { classNamez, Modal, useModal, useViewport } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"
import { AnimatePresence, m } from "framer-motion"
import { useCallback, useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import MyParadiseAddressModal from "../MyParadiseAddressModal/MyParadiseAddressModal"
import { MyParadiseDeleteModal } from "../MyParadiseDeleteModal/MyParadiseDeleteModal"
import "./MyParadiseDataModal.css"

const MyParadiseDataModal = () => {
	const relLoggedIn = useSelector(state => state.core.flow === "relation")
	const { sm } = useViewport()
	const [showDeleteDialog, setShowDeleteDialog] = useState(false)
	const [showInvoiceAddresses, setShowInvoiceAddresses] = useState(false)
	const [showDeliveryAddress, setShowDeliveryAddresses] = useState(false)

	const { hideModal, showModal } = useModal()
	const [saveUserData, { isFetching: userDataFetching }] = useSaveUserData()
	const [deleteUser, { isFetching: deleteFetching }] = useDeleteUserData()
	const { push } = useCustomNavigation()

	const { data: userData, refetch } = useGetRelation(undefined, { skip: !relLoggedIn })
	const [showCompany, setShowCompany] = useState(userData && userData.companyName ? true : false)
	const { data: salutations } = useGetSalutations()
	const { data: countries } = useGetCountries()
	const { data: addresses, isLoading: addressesLoading } = useGetRelationAddresses()
	const {
		data: {
			clientTypes,
			placeholderFirstName,
			placeholderLastName,
			placeholderPhone,
			labelSalutation,
			placeholderCountry,
			placeholderCompany,
			placeholderVATNumber,
			requiredFields,
			pleaseSelect,
			dataModalTitle,
			dataModalAccountType,
			buttonDeleteAccount,
			buttonSave,
			errorInputMissingFirstName,
			errorInputMissingLastName,
			errorInputMissingSalutation,
			errorInputMissingCompany,
			errorInputMissingVATNumber,
			errorInputMissingCountry,
			invoiceAddress,
			deliveryAddress,
		},
	} = useGetStrings(undefined, { defaultData: {} })

	const {
		register,
		handleSubmit,
		formState: { errors },
		getValues,
		setValue,
	} = useForm({
		mode: "onTouched",
	})

	useEffect(() => {
		if (countries && (!getValues().countryId || getValues().countryId.length === 0)) {
			setValue("countryId", "60")
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		if (userData) {
			setValue("salutation", userData.genderId ? userData.genderId + "" : undefined)
			setValue("firstName", userData.firstName)
			setValue("lastName", userData.lastName)
			setValue("phoneNo", userData.phoneNo)
			// setValue("street", street)
			// setValue("zipCode", userData.zipCode)
			// setValue("city", userData.city)
			setValue("countryId", userData.countryId)
			setValue("companyName", userData.companyName)
			setValue("vatNumber", userData.vatNumber)
			setValue("accountType", userData && userData.relationTypeId == 2 ? "firma" : "privat")
			setShowCompany(userData && userData.relationTypeId === 2 ? true : false)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userData])

	const deleteAccount = useCallback(async () => {
		let result = await deleteUser()
		if (result) {
			hideModal()
			useLogout.blank().then(() => {
				window.location.reload()
			})
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [hideModal, deleteUser])

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const onSaveClick = useCallback(async () => {
		handleSubmit(async data => {
			data.genderId = parseInt(data.salutation)
			let result = await saveUserData(data)
			if (result) {
				refetch().then(relation => appStore.set("core.relation", relation.data))
				hideModal()
				push("/myParadise")
			}
		})()
	})

	return (
		<Modal className="customModal">
			<Modal.Closer />
			<Modal.Header>{dataModalTitle}</Modal.Header>
			{showDeleteDialog && (
				<div style={{ position: "absolute", backgroundColor: "rgba(0,0,0,0.7)" }} className="h-100 w-100 flex flex-center z-9">
					<MyParadiseDeleteModal
						onClose={() => {
							setShowDeleteDialog(false)
						}}
						onDelete={deleteAccount}
					/>
				</div>
			)}
			<Modal.Body>
				<div>
					<div className="myParadiseDataModal__inputRow myParadiseDataModal__inputRow--3">
						<div>
							<div className="semibold mb-2">{labelSalutation} *</div>
							<div className="flex">
								{(salutations || []).map((e, i) => (
									<div key={i} className={classNamez({ "ml-3": i !== 0 })}>
										<input
											id={e.salutation}
											type="radio"
											{...register("salutation", { required: { value: true, message: errorInputMissingSalutation } })}
											value={e.genderId}
										/>
										<label htmlFor={e.salutation} className="ml-2">
											{e.salutation}
										</label>
									</div>
								))}
							</div>
							<InputError message={errors.salutation ? errors.salutation.message : undefined} />
						</div>
						<div>
							<div className="semibold mb-2">{dataModalAccountType} *</div>
							<div className="flex">
								{(clientTypes || []).map((e, i) => (
									<div key={i} className={classNamez({ "ml-3": i !== 0 })}>
										<input
											id={e.value}
											type="radio"
											{...register("accountType", { required: { value: true, message: "missing" } })}
											value={e.value}
											onChange={e => {
												setShowCompany(e.target.value === "firma")
											}}
										/>
										<label htmlFor={e.value} className="ml-2">
											{e.name}
										</label>
									</div>
								))}
							</div>
							<InputError message={errors.accountType ? errors.accountType.message : undefined} />
						</div>
					</div>

					{showCompany && (
						<div className="myParadiseDataModal__inputRow myParadiseDataModal__inputRow--3">
							<div>
								<Input
									type="text"
									label={placeholderCompany + "*"}
									formRegister={register("companyName", {
										required: {
											value: true,
											message: errorInputMissingCompany,
										},
									})}
									errors={errors}
								/>
							</div>
							<div>
								<Input
									type="text"
									label={placeholderVATNumber + "*"}
									formRegister={register("vatNumber", {
										required: {
											value: true,
											message: errorInputMissingVATNumber,
										},
									})}
									errors={errors}
								/>
							</div>
						</div>
					)}

					<div className="myParadiseDataModal__inputRow myParadiseDataModal__inputRow--3">
						<div>
							<Input
								name="firstname"
								type="text"
								label={placeholderFirstName + "*"}
								autocomplete="given-name"
								disabled={!!userData?.memberCode}
								formRegister={register("firstName", {
									required: {
										value: true,
										message: errorInputMissingFirstName,
									},
								})}
								errors={errors}
							/>
						</div>
						<div>
							<Input
								name="lastname"
								type="text"
								label={placeholderLastName + "*"}
								autocomplete="family-name"
								formRegister={register("lastName", {
									required: {
										value: true,
										message: errorInputMissingLastName,
									},
								})}
								errors={errors}
							/>
						</div>
					</div>

					<div className="myParadiseDataModal__inputRow mt-4">
						<Input name="phoneNo" type="tel" label={placeholderPhone} autocomplete="on" formRegister={register("phoneNo", {})} errors={errors} />
					</div>

					<div className="myParadiseDataModal__inputRow mt-4">
						<SelectBox
							classname="selectbox border rounded-1 fill"
							autocomplete="country"
							formRegister={register("countryId", {
								required: {
									value: true,
									message: errorInputMissingCountry,
								},
							})}
							onChange={e => {
								setValue("countryId", e.target.value)
							}}
							errors={errors}
							label={placeholderCountry + "*"}
						>
							<option value="" disabled style={{ display: "none" }}>
								{pleaseSelect}
							</option>
							{countries &&
								countries.map(country => {
									return (
										<option key={country.countryId} value={country.countryId}>
											{country.country}
										</option>
									)
								})}
						</SelectBox>
					</div>

					<div className="mt-3 regular color-fg-default">* {requiredFields}</div>
				</div>

				<div className="mt-4">
					<div className="">
						<div className="mb-3 flex flex-justify-between clickable" onClick={() => setShowInvoiceAddresses(!showInvoiceAddresses)}>
							<div>{invoiceAddress}</div>
							<div>
								<FontAwesomeIcon icon={showInvoiceAddresses ? faChevronDown : faChevronRight} />
							</div>
						</div>
						<AnimatePresence>
							{showInvoiceAddresses && (
								<m.div
									className="z-9 of-hidden w-100 "
									style={{ originY: 0 }}
									initial={{
										height: 0,
									}}
									animate={{
										height: "auto",
										transition: {
											duration: 0.4,
										},
									}}
									exit={{
										height: 0,
										transition: { duration: 0.4 },
									}}
								>
									<Loader show={addressesLoading} />
									{addresses
										.filter(e => e.addressTypeId === ADRESS_TYPES.INVOICE)
										.map(e => (
											<AddressEntry key={e.addressToken} address={e} editable openModalAfterUpdate={MyParadiseDataModal} />
										))}
									<Button
										fillWidth
										style="outlined"
										className="primary"
										onClick={() => {
											showModal(MyParadiseAddressModal, {
												addressTypeId: ADRESS_TYPES.INVOICE,
												openModalAfterUpdate: MyParadiseDataModal,
											})
										}}
									>
										<div className="medium">+ Adresse hinzufügen</div>
									</Button>
								</m.div>
							)}
						</AnimatePresence>
					</div>
				</div>
				<div className="mt-4">
					<div className="">
						<div className="mb-3 flex flex-justify-between clickable" onClick={() => setShowDeliveryAddresses(!showDeliveryAddress)}>
							<div>{deliveryAddress}</div>
							<div>
								<FontAwesomeIcon icon={showDeliveryAddress ? faChevronDown : faChevronRight} />
							</div>
						</div>
						<AnimatePresence>
							{showDeliveryAddress && (
								<m.div
									className="z-9 of-hidden w-100 "
									style={{ originY: 0 }}
									initial={{
										height: 0,
									}}
									animate={{
										height: "auto",
										transition: {
											duration: 0.4,
										},
									}}
									exit={{
										height: 0,
										transition: { duration: 0.4 },
									}}
								>
									<Loader show={addressesLoading} />
									{addresses
										.filter(e => e.addressTypeId === ADRESS_TYPES.DELIVERY)
										.map(e => (
											<AddressEntry key={e.addressToken} address={e} editable openModalAfterUpdate={MyParadiseDataModal} />
										))}
									<Button
										fillWidth
										style="outlined"
										className="primary"
										onClick={() => {
											showModal(MyParadiseAddressModal, {
												addressTypeId: ADRESS_TYPES.DELIVERY,
												openModalAfterUpdate: MyParadiseDataModal,
											})
										}}
									>
										<div className="medium">+ Adresse hinzufügen</div>
									</Button>
								</m.div>
							)}
						</AnimatePresence>
					</div>
				</div>
			</Modal.Body>

			<Modal.Footer>
				<div className={sm ? "flex flex-column flex-align-center mt-4 mb-2" : "flex flex-justify-between mt-4 mb-2 "}>
					<Button style="secondary" className={sm && "mb-3"} onClick={() => setShowDeleteDialog(true)} isLoading={deleteFetching}>
						{buttonDeleteAccount}
					</Button>
					<Button style="primary" onClick={onSaveClick} isLoading={userDataFetching}>
						{buttonSave}
					</Button>
				</div>
			</Modal.Footer>
		</Modal>
	)
}

export default MyParadiseDataModal
